import React, { FC } from 'react'
import { Bullet } from 'components/atoms/icons'
import { InlineMessage, INLINE_MESSAGE_VARIANTS } from 'transfix-ui/components/InlineMessage'
import { ITodo } from 'apps/fleet-planner/types'

interface ITodosListRowMessageProps {
  todo: ITodo
}

export const TodosListRowMessage: FC<ITodosListRowMessageProps> = ({ todo }) => {
  const { missingDriver, missingTruckNumber, missingVin, podMissing, podRejected } = todo || {}

  const hasPodTodos = podMissing || podRejected
  const hasTodos = missingDriver || missingTruckNumber || missingVin

  const generatePodLine = () => {
    if (podMissing) {
      return 'Upload POD'
    }
    if (podRejected) {
      return 'Replace rejected POD'
    }
    return ''
  }

  const generateMissingLine = () => {
    if (!hasTodos) return ''

    const missingLine = 'Add a '
    const missingItems: string[] = []
    if (missingDriver) missingItems.push('driver')
    if (missingTruckNumber) missingItems.push('truck')
    if (missingVin) missingItems.push('Tractor VIN')

    // creates a string with commas inbetween
    return `${missingLine}${missingItems.join(', ')}`
  }

  const generateTodoMessage = () => {
    const needsBullets = hasPodTodos && hasTodos

    return (
      <div>
        <p>
          {needsBullets && <Bullet />} {generateMissingLine()}
        </p>
        <p>
          {needsBullets && <Bullet />} {generatePodLine()}
        </p>
      </div>
    )
  }

  return <InlineMessage message={generateTodoMessage()} type={INLINE_MESSAGE_VARIANTS.WARNING} />
}
